import Resizable from "re-resizable";
import * as React from "react";
import {Dropdown, Input, InputOnChangeData, MenuItemProps, Table} from "semantic-ui-react";
import TablePagination from "../../components/Table/components/footerComponents/pagination/TablePagination";
import {TechnicalDataDto} from "../../services/Client";

const Pt3TechIdKey = "pt3TechId";
const PccdTechNameKey = "pccdTechName";
const TechUnitKey = "techUnit";
const TechValueKey = "techValue";
const FurtherSpecsKey = "furtherSpecs";
const TypificationKey = "typification";
const SourceKey = "source";
const GroupKey = "group";
const AssignedGroupKey = "assignedGroup";
const SalesNameKey = "salesName";
const LastChangeKey = "lastChange";

interface ITechnicalDataTableProps {
    t: reactI18Next.TranslationFunction;

    technicalData: TechnicalDataDto[];

    contextSelected: boolean;
}

interface ITechnicalDataTableState {
    activePage: number;
    numberOfItems: number;
    filterValues: {[key: string]: any};
    approvedStatusFilter: string;
    gearFilter: string;
}

export class TechnicalDataTable extends React.Component<ITechnicalDataTableProps, ITechnicalDataTableState> {

    constructor(props: ITechnicalDataTableProps) {
        super(props);

        this.state = {
            activePage: 1,
            numberOfItems: 15,
            filterValues: {},
            approvedStatusFilter: '',
            gearFilter: ''
        };
    }

    getHeaderCell = (columnName: string, columnKey: string, defaultWidth: number) => {
        return (
            <Table.HeaderCell style={{backgroundColor: '#eff0f1', fontSize: 'smaller'}}>
                <>
                    {columnName}
                    <Resizable
                        defaultSize={{width: defaultWidth}}
                        minWidth={100}
                        enable={{top: false, right: true, bottom: false, left: false, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false}}
                    >
                        <Input
                            fluid={true}
                            value={this.state.filterValues[columnKey]}
                            onChange={(e: React.SyntheticEvent<HTMLElement>, data: InputOnChangeData) => {
                                const filter = {...this.state.filterValues};
                                filter[columnKey] = data.value as string;

                                this.setState({filterValues: filter});
                            }}
                        />
                    </Resizable>
                </>
            </Table.HeaderCell>
        );
    }

    getBodyCell = (value: any) => {
        return (
            <Table.Cell>{value}</Table.Cell>
        );
    }

    filterData = () => {
        const filterKeys = this.buildFilterKeysWithValue();

        let filteredData = this.props.technicalData.filter((item) => {
            const filterKeysStates: boolean[] = filterKeys.map((key) => {
                switch (key) {
                    case (Pt3TechIdKey):
                        return item.pt3TechId !== undefined &&
                            item.pt3TechId.toLocaleLowerCase().indexOf(this.state.filterValues[key].toLocaleLowerCase()) !== -1;
                    case (PccdTechNameKey):
                        return item.pccdTechName !== undefined &&
                            item.pccdTechName.toLocaleLowerCase().indexOf(this.state.filterValues[key].toLocaleLowerCase()) !== -1;
                    case (TechUnitKey):
                        return item.techUnit !== undefined &&
                            item.techUnit.toLocaleLowerCase().indexOf(this.state.filterValues[key].toLocaleLowerCase()) !== -1;
                    case (TechValueKey):
                        return item.techValue !== undefined &&
                            item.techValue.toLocaleLowerCase().indexOf(this.state.filterValues[key].toLocaleLowerCase()) !== -1;
                    case (FurtherSpecsKey):
                        return item.furtherSpecs !== undefined &&
                            item.furtherSpecs.toLocaleLowerCase().indexOf(this.state.filterValues[key].toLocaleLowerCase()) !== -1;
                    case (TypificationKey):
                        return item.typification !== undefined &&
                            item.typification.toLocaleLowerCase().indexOf(this.state.filterValues[key].toLocaleLowerCase()) !== -1;
                    case (SourceKey):
                        return item.source !== undefined &&
                            item.source.toLocaleLowerCase().indexOf(this.state.filterValues[key].toLocaleLowerCase()) !== -1;
                    case (GroupKey):
                        return item.group !== undefined &&
                            item.group.toLocaleLowerCase().indexOf(this.state.filterValues[key].toLocaleLowerCase()) !== -1;
                    case (AssignedGroupKey):
                        return item.assignedGroup !== undefined &&
                            item.assignedGroup.toLocaleLowerCase().indexOf(this.state.filterValues[key].toLocaleLowerCase()) !== -1;
                    case (SalesNameKey):
                        return item.salesName !== undefined &&
                            item.salesName.toLocaleLowerCase().indexOf(this.state.filterValues[key].toLocaleLowerCase()) !== -1;
                    case (LastChangeKey):
                        return item.lastChange !== undefined &&
                            item.lastChange.toLocaleLowerCase().indexOf(this.state.filterValues[key].toLocaleLowerCase()) !== -1;
                    default:
                        return true;
                }
            });

            return filterKeysStates.findIndex((val) => val === false) === -1;
        });

        if (this.state.gearFilter) {
            filteredData = filteredData.filter((item) => item.gear !== undefined &&
                item.gear.toLocaleLowerCase().indexOf(this.state.gearFilter.toLocaleLowerCase()) !== -1);
        }

        if (this.state.approvedStatusFilter) {
            filteredData = filteredData.filter((item) => item.approvedStatus !== undefined &&
                item.approvedStatus.toLocaleLowerCase().indexOf(this.state.approvedStatusFilter.toLocaleLowerCase()) !== -1);
        }

        return filteredData;
    }

    buildFilterKeysWithValue = () => {
        return Object.keys(this.state.filterValues).filter((key) => this.state.filterValues[key] !== "" && this.state.filterValues[key] !== undefined);
    }

    render() {
        const filteredData = this.filterData();
        const items = filteredData.slice((this.state.activePage - 1) * this.state.numberOfItems, this.state.activePage * this.state.numberOfItems);

        let gearDataSource: Set<string> = new Set<string>();
        let approvedDataSource: Set<string> = new Set<string>();
        this.props.technicalData.forEach((val) => {
            if (val.gear && !gearDataSource.has(val.gear)) {
                gearDataSource.add(val.gear);
            }

            if (val.approvedStatus && !approvedDataSource.has(val.approvedStatus)) {
                approvedDataSource.add(val.approvedStatus);
            }
        });

        return (
            <>
                <Table
                    celled={true}
                    className={'technical-data-table'}
                    style={{width: '100%', display: 'flex', flexDirection: 'column'}}
                >
                    <div style={{overflow: 'scroll', height: window.innerHeight - 210}}>
                        <Table.Header style={{position: 'sticky', top: '0'}}>
                            <Table.Row>
                                {this.getHeaderCell(this.props.t('TECH_DATA_VIEW:PT3_TECH_ID'), Pt3TechIdKey, 100)}
                                {this.getHeaderCell(this.props.t('TECH_DATA_VIEW:PCCD_TECH_NAME'), PccdTechNameKey, 200)}
                                {this.getHeaderCell(this.props.t('TECH_DATA_VIEW:TECH_UNIT'), TechUnitKey, 100)}
                                {this.getHeaderCell(this.props.t('TECH_DATA_VIEW:TECH_VALUE'), TechValueKey, 100)}
                                {this.getHeaderCell(this.props.t('TECH_DATA_VIEW:FURTHER_SPECS'), FurtherSpecsKey, 200)}
                                <Table.HeaderCell style={{backgroundColor: '#eff0f1', fontSize: 'smaller'}}>
                                    <Resizable
                                        defaultSize={{width: 100}}
                                        minWidth={100}
                                        enable={{top: false, right: true, bottom: false, left: false, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false}}
                                    >
                                        {this.props.t('TECH_DATA_VIEW:GEAR')}
                                        <Dropdown
                                            selection={true}
                                            fluid={true}
                                            clearable={false}
                                            value={this.state.gearFilter}
                                            onChange={(e, v) => this.setState({gearFilter: v.value as string})}
                                            options={gearDataSource.size > 0 ? [{
                                                key: '',
                                                text: '',
                                                value: ''
                                            }, ...Array.from(gearDataSource).map((item) => ({
                                                key: item,
                                                text: item,
                                                value: item
                                            }))] : []}
                                        />
                                    </Resizable>
                                </Table.HeaderCell>
                                {this.getHeaderCell(this.props.t('TECH_DATA_VIEW:TYPIFICATION'), TypificationKey, 100)}
                                <Table.HeaderCell style={{backgroundColor: '#eff0f1', fontSize: 'smaller'}}>
                                    <Resizable
                                        defaultSize={{width: 150}}
                                        minWidth={100}
                                        enable={{top: false, right: true, bottom: false, left: false, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false}}
                                    >
                                        {this.props.t('TECH_DATA_VIEW:APPROVED_STATUS')}
                                        <Dropdown
                                            fluid={true}
                                            selection={true}
                                            clearable={false}
                                            value={this.state.approvedStatusFilter}
                                            onChange={(e, v) => this.setState({approvedStatusFilter: v.value as string})}
                                            options={approvedDataSource.size > 0 ? [{
                                                key: '',
                                                text: '',
                                                value: ''
                                            }, ...Array.from(approvedDataSource).map((item) => ({
                                                key: item,
                                                text: this.props.t('TECH_DATA_VIEW:APPROVED_STATUS_' + item),
                                                value: item
                                            }))] : []}
                                        />
                                    </Resizable>
                                </Table.HeaderCell>
                                {this.getHeaderCell(this.props.t('TECH_DATA_VIEW:SOURCE'), SourceKey, 100)}
                                {this.getHeaderCell(this.props.t('TECH_DATA_VIEW:GROUP'), GroupKey, 100)}
                                {this.getHeaderCell(this.props.t('TECH_DATA_VIEW:ASSIGNED_GROUP'), AssignedGroupKey, 120)}
                                {this.getHeaderCell(this.props.t('TECH_DATA_VIEW:SALES_NAME'), SalesNameKey, 120)}
                                {this.getHeaderCell(this.props.t('TECH_DATA_VIEW:LAST_CHANGE'), LastChangeKey, 100)}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {filteredData.length > 0 ?
                                items.map((techDto: TechnicalDataDto, index: number) =>
                                    <Table.Row key={'tech-item-' + index}>
                                        {this.getBodyCell(techDto.pt3TechId)}
                                        {this.getBodyCell(techDto.pccdTechName)}
                                        {this.getBodyCell(techDto.techUnit)}
                                        {this.getBodyCell(techDto.techValue)}
                                        {this.getBodyCell(techDto.furtherSpecs)}
                                        {this.getBodyCell(techDto.gear)}
                                        {this.getBodyCell(techDto.typification)}
                                        <Table.Cell>
                                            {techDto.approvedStatus === '0' || techDto.approvedStatus === '1'
                                                ? this.props.t('TECH_DATA_VIEW:APPROVED_STATUS_' + techDto.approvedStatus)
                                                : this.props.t('TECH_DATA_VIEW:UNKNOWN_APPROVED_STATUS', {status: techDto.approvedStatus})}
                                        </Table.Cell>
                                        {this.getBodyCell(techDto.source)}
                                        {this.getBodyCell(techDto.group)}
                                        {this.getBodyCell(techDto.assignedGroup)}
                                        {this.getBodyCell(techDto.salesName)}
                                        {this.getBodyCell(techDto.lastChange)}
                                    </Table.Row>)
                                : <Table.Row>
                                    <Table.Cell
                                        colSpan={13}
                                        className={this.props.contextSelected ? 'technical-data-table-empty' : 'technical-data-table-no-context'}
                                    >
                                        {this.props.t(this.props.contextSelected ? this.props.t('GLOBAL:NO_DATA') : 'TECH_DATA_VIEW:NO_CONTEXT_SELECTED')}
                                    </Table.Cell>
                                </Table.Row>}
                        </Table.Body>
                    </div>
                    <Table.Footer>
                        <Table.Row style={{display: 'flex', flexDirection: 'column'}}>
                            <Table.HeaderCell colSpan={13}>
                                <div className='virtualized-table-pagination-footer' >
                                    <TablePagination
                                        numberOfItems={this.state.numberOfItems}
                                        setNumberOfItems={(e: React.MouseEvent<HTMLAnchorElement>, data: MenuItemProps) =>
                                            this.setState({
                                                numberOfItems: data.value,
                                                activePage: 1,
                                            })}
                                        dataLength={this.props.technicalData.length}
                                        customNoOfItems={[15, 30, 60]}
                                        hasScrollBtn={false}
                                        filteredDataLength={filteredData.length}
                                        t={this.props.t}
                                        currentPage={this.state.activePage}
                                        onPageChange={(e, c) => this.setState({activePage: c.activePage as number})}
                                    />
                                </div>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table >
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/TechnicalDataView/TechnicalDataTable.tsx